import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import SportsEsportsRoundedIcon from '@mui/icons-material/SportsEsportsRounded';

const DARK = '#1a1a1a';
const GREEN = '#15803d';
const GREEN_BG = '#ecfdf5';

function LudoTermsDialog({ open, onClose }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: '16px',
          overflow: 'hidden',
          bgcolor: '#fff',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          fontWeight: 800,
          fontSize: '1rem',
          color: '#fff',
          bgcolor: GREEN,
          py: 1.5,
        }}
      >
        <SportsEsportsRoundedIcon sx={{ color: '#fff' }} />
        Ludo — Terms &amp; Conditions
      </DialogTitle>

      <DialogContent dividers sx={{ bgcolor: '#fff', color: DARK, px: 2, py: 2 }}>
        <Typography sx={{ fontSize: '0.9rem', fontWeight: 700, color: DARK, mb: 1.5 }}>
          2-player PvP · real-money stakes · winner takes the pool (after fees)
        </Typography>

        <Box component="ul" sx={{ m: 0, pl: 2.2, color: DARK }}>
          <Typography component="li" sx={{ fontSize: '0.88rem', mb: 1, lineHeight: 1.5 }}>
            Both players put the same stake before the match starts. The total pool is both stakes combined.
          </Typography>
          <Typography component="li" sx={{ fontSize: '0.88rem', mb: 1, lineHeight: 1.5 }}>
            <Box component="span" sx={{ fontWeight: 800 }}>7% platform commission</Box> is deducted from
            the total pool. The winner receives the remaining amount in their wallet.
          </Typography>
        </Box>

        <Box
          sx={{
            mt: 1.5,
            p: 1.5,
            borderRadius: '12px',
            bgcolor: GREEN_BG,
            border: '2px solid #22c55e',
          }}
        >
          <Typography sx={{ fontSize: '0.92rem', fontWeight: 800, color: GREEN, mb: 1 }}>
            Dice roll timer
          </Typography>
          <Typography sx={{ fontSize: '0.85rem', color: DARK, lineHeight: 1.5, mb: 0.75 }}>
            When it is your turn to roll, you get a <strong>30 second</strong> grace period, then a{' '}
            <strong>3 minute</strong> countdown (<strong>3.5 minutes total</strong>). Both players see
            the timer.
          </Typography>
          <Typography sx={{ fontSize: '0.85rem', color: DARK, lineHeight: 1.5 }}>
            If you do not roll the dice in time, you forfeit and your opponent wins the pool. Your
            opponent is shown a countdown and told they win if you do not roll in time.
          </Typography>
        </Box>

        <Box
          sx={{
            mt: 1.5,
            p: 1.5,
            borderRadius: '12px',
            bgcolor: '#fff7ed',
            border: '2px solid #fb923c',
          }}
        >
          <Typography sx={{ fontSize: '0.92rem', fontWeight: 800, color: '#c2410c', mb: 1 }}>
            Move timer
          </Typography>
          <Typography sx={{ fontSize: '0.85rem', color: DARK, lineHeight: 1.5, mb: 0.75 }}>
            After rolling, you have <strong>30 seconds</strong> to move a token.
          </Typography>
          <Typography sx={{ fontSize: '0.85rem', color: DARK, lineHeight: 1.5 }}>
            If you do not move in time, the game moves a token for you automatically. This counts as{' '}
            <strong>1 timeout</strong>. After <strong>3 timeouts</strong> in one match, you forfeit and
            lose your stake.
          </Typography>
        </Box>

        <Box component="ul" sx={{ m: '14px 0 0', pl: 2.2, color: DARK }}>
          <Typography component="li" sx={{ fontSize: '0.82rem', color: '#333', mb: 0.6, lineHeight: 1.45 }}>
            Leaving or quitting mid-game counts as a forfeit — you lose and your opponent wins.
          </Typography>
          <Typography component="li" sx={{ fontSize: '0.82rem', color: '#333', lineHeight: 1.45 }}>
            Free practice vs Bot is available in the lobby — no wallet charge.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ bgcolor: '#fff', px: 2, pb: 2, pt: 1 }}>
        <Button
          variant="contained"
          onClick={onClose}
          fullWidth
          sx={{
            fontWeight: 800,
            borderRadius: '999px',
            bgcolor: GREEN,
            py: 1.2,
            '&:hover': { bgcolor: '#14532d' },
          }}
        >
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default LudoTermsDialog;
